import { useMutation } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type { LandscapeData } from "@/types/landscape";

export function useLandscapeData(conceptId: string) {
  return useMutation({
    mutationFn: () =>
      apiClient
        .post(`api/concepts/${conceptId}/landscape`, { timeout: 30_000 })
        .json<LandscapeData>(),
  });
}
